<template>
  <div v-if="exampleLocal" class="input-example_iel">
    <span class="iel_label">Пример:</span> {{ exampleLocal }}
  </div>
</template>

<script>
export default {
  props: ['example'],
  data() {
    return {
      exampleLocal: '',
    };
  },
  created() {
    if (this.example && this.example.length) {
      this.exampleLocal = this.example;
    }
  },
};
</script>

<style lang="scss">
.input-example_iel {
  font-size: 14px;
  padding-top: 15px;
  color: rgba(255, 255, 255, .5);
  .iel_label {
    color: #ededed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/elements/InputExample.vue